import type { ReactNode } from 'react';

export interface TimelineEvent {
  key: string;
  date: string;
  time?: string;
  caption: ReactNode;
  /** Optional heading shown above the event (e.g. year). */
  title?: string;
}

/**
 * idsk/components/timeline. The "past/future events" buttons of the template are omitted: ID-SK 2.11 ships no
 * script for them, and buttons without behaviour would be confusing for keyboard and screen-reader users.
 * The events are exposed as an ordered list (visually identical) so the sequence is announced.
 */
export function Timeline({ label, events }: { label: string; events: TimelineEvent[] }) {
  return (
    <div className="idsk-timeline" data-module="idsk-timeline">
      <div className="govuk-container-width">
        <ol className="govuk-list app-timeline-list" aria-label={label}>
          {events.map((event) => (
            <li key={event.key}>
              {event.title && (
                <div className="idsk-timeline__content idsk-timeline__content__title-div">
                  <div className="idsk-timeline__left-side" />
                  <div className="idsk-timeline__middle">
                    <span className="idsk-timeline__vertical-line" />
                  </div>
                  <div className="idsk-timeline__content__title">
                    <h3 className="govuk-heading-m">{event.title}</h3>
                  </div>
                </div>
              )}
              <div className="idsk-timeline__content idsk-timeline__content__caption--long">
                <div className="idsk-timeline__left-side">
                  <span className="govuk-body-m">{event.date}</span>
                  {event.time && (
                    <>
                      <br />
                      <span className="idsk-timeline__content__time">{event.time}</span>
                    </>
                  )}
                </div>
                <div className="idsk-timeline__middle">
                  <span className="idsk-timeline__vertical-line--circle" />
                </div>
                <div className="idsk-timeline__content__caption">
                  <div className="govuk-body">{event.caption}</div>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
